import { inject, Injectable } from '@angular/core';
import { Person } from '../classes/person.class';
import { Params } from '@angular/router';
import { Order } from '../classes/order.class';
import { getTimeOffset } from '../utils/date-format';
import { TimeZoneService } from './time-zone.service';

@Injectable({
    providedIn: 'root'
})
export class MainPageService {
    private timeZoneService = inject(TimeZoneService);

    getNonWorkingTimeGradient(worker: Person, startTime: number, endTime: number, query: Params): string {
        const daysMatch: { [key: number]: number } = { // соотношение дней недели расписания и getDay()
            1: 0,
            2: 1,
            3: 2,
            4: 3,
            5: 4,
            6: 5,
            0: 6
        };

        const arr = query['filter.dateFrom'].split(',');
        const today = this.timeZoneService.setCurrentTimeZoneDate(new Date(arr[1])).getDay();
        const scheduleParams = worker.data.scheduleParams || {
            endLunchTime: '00:00',
            endWorkTime: '00:00',
            startLunchTime: '00:00',
            startWorkTime: '00:00'
        };

        const workerCalendar = Object.values(scheduleParams);
        let start = 0;
        let end = 0;

        // TODO если нужно будет преобразовывать время работника
        // const startWorkTime = this.timeZoneService.setTimeZoneWorkTime(workerCalendar[daysMatch[today]]?.startWorkTime);
        // const endWorkTime = this.timeZoneService.setTimeZoneWorkTime(workerCalendar[daysMatch[today]]?.endWorkTime);

        const startWorkTime = workerCalendar[daysMatch[today]]?.startWorkTime;
        const endWorkTime = workerCalendar[daysMatch[today]]?.endWorkTime;
        if(workerCalendar[daysMatch[today]] && startWorkTime) {
            start = Number(startWorkTime.split(':')[0]);
        }

        if(workerCalendar[daysMatch[today]] && endWorkTime) {
            end = Number(endWorkTime.split(':')[0]);
        }

        const workStartPercent = (start / (endTime - startTime)) * 100;
        const workEndPercent = (end / (endTime - startTime)) * 100;

        if (end > start) {
            // Нормальный случай: рабочий день в пределах одних суток
            return `linear-gradient(to right,
            rgba(184, 177, 177, 0.7) 0%,
            rgba(184, 177, 177, 0.7) ${workStartPercent}%,
            rgba(227, 222, 222, 0.49) ${workStartPercent}%,
            rgba(227, 222, 222, 0.49) ${workEndPercent}%,
            rgba(184, 177, 177, 0.7) ${workEndPercent}%
        )`;
        } else if (end < start) {
            // Случай когда рабочий день переходит через полночь
            return `linear-gradient(to right,
            rgba(227, 222, 222, 0.49) 0%,
            rgba(227, 222, 222, 0.49) ${workEndPercent}%,
            rgba(184, 177, 177, 0.7) ${workEndPercent}%,
            rgba(184, 177, 177, 0.7) ${workStartPercent}%,
            rgba(227, 222, 222, 0.49) ${workStartPercent}%
        )`;
        } else {
            return 'rgba(184, 177, 177, 0.7)';
        }
    }

    calculateTaskStyle(task: Order, time: string, tasks: Order[], startTime: number, endTime: number, cardWidth: number): { [key: string]: string } {
        const taskHour = new Date(task.data.dateFrom).getUTCHours();

        const currentTimeOrders = tasks.filter(el => taskHour === new Date(el.data.dateFrom).getUTCHours());

        // Вычисляем индекс задачи в слоте
        const taskIndex = currentTimeOrders.indexOf(task);
        // Вычисляем положение первой заявки
        const leftPercent = (taskHour + getTimeOffset() - startTime) / (endTime - startTime) * 100;
        // Смещение по горизонтали для текущей задачи
        const offsetX = taskIndex * cardWidth;

        return {
            left:`calc(${leftPercent}% + ${offsetX}px)`,
            width: `${cardWidth}px`, // Фиксированная ширина карточки
            position: 'absolute', // Позиционируем карточку абсолютно
        };
    }

}
